import { AnySidebarItem } from '@vdms-hq/ui';
import { FIELDS_BASE_PATHS } from './base-paths';
import type { ClientAdminViewModel } from '@vdms-hq/client-admin-core';
import { FieldsScopeKey } from '@vdms-hq/fields';

type ConfigurableScopes = Exclude<FieldsScopeKey, '_admin-all-fields' | '_any'>;

export type ResultsAdminConfig = {
  key: ConfigurableScopes;
  name: string;
  hasTable: boolean;
  hasList: boolean;
  hasFilters: boolean;
};
export type FieldsAdminConfig = ResultsAdminConfig[];

export const resultsAdminConfig: FieldsAdminConfig = [
  {
    key: 'default',
    name: 'common.admin.sidebar.tables_and_lists.assets_default',
    hasFilters: false,
    hasList: true,
    hasTable: true,
  },
  {
    key: 'metadata-snapshots',
    name: 'common.admin.sidebar.tables_and_lists.metadata_snapshots',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'metadata-recognition',
    name: 'common.admin.sidebar.tables_and_lists.filename-conventions',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'deleted',
    name: 'common.admin.sidebar.tables_and_lists.assets_deleted',
    hasList: true,
    hasTable: true,
    hasFilters: true,
  },
  {
    key: 'quarantined',
    name: 'common.admin.sidebar.tables_and_lists.assets_quarantined',
    hasList: true,
    hasTable: true,
    hasFilters: true,
  },
  {
    key: 'qc-required',
    name: 'common.admin.sidebar.tables_and_lists.assets_qc_required',
    hasList: true,
    hasTable: true,
    hasFilters: true,
  },
  {
    key: 'asset-kits-qc',
    name: 'common.admin.sidebar.tables_and_lists.assets_link_revision_qc',
    hasTable: true,
    hasList: false,
    hasFilters: true,
  },
  {
    key: 'browse',
    name: 'common.admin.sidebar.tables_and_lists.assets_browse',
    hasList: true,
    hasTable: true,
    hasFilters: true,
  },
  {
    key: 'adobe-panel',
    name: 'common.admin.sidebar.tables_and_lists.assets_adobe_panel',
    hasList: true,
    hasTable: true,
    hasFilters: true,
  },
  {
    key: 'cart',
    name: 'common.admin.sidebar.tables_and_lists.assets_cart',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'collections',
    name: 'common.admin.sidebar.tables_and_lists.assets_collections',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'projects',
    name: 'common.admin.sidebar.tables_and_lists.assets_projects',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'shared-packs',
    name: 'common.admin.sidebar.tables_and_lists.assets_shared_packs',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'orders',
    name: 'common.admin.sidebar.tables_and_lists.assets_orders',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'upload-jobs-draft',
    name: 'common.admin.sidebar.tables_and_lists.assets_upload_jobs_draft',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'upload-jobs-pending',
    name: 'common.admin.sidebar.tables_and_lists.assets_upload_jobs_pending',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'upload-jobs-rejected',
    name: 'common.admin.sidebar.tables_and_lists.assets_upload_jobs_rejected',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'upload-jobs-approved',
    name: 'common.admin.sidebar.tables_and_lists.assets_upload_jobs_approved',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'upload-jobs-my-uploads',
    name: 'common.admin.sidebar.tables_and_lists.assets_upload_jobs_my_uploads',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'connect2',
    name: 'common.admin.sidebar.tables_and_lists.assets_connect2',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'licensed-package',
    name: 'common.admin.sidebar.tables_and_lists.assets_licensed_package',
    hasTable: true,
    hasList: true,
    hasFilters: true,
  },
  {
    key: 'preview-request',
    name: 'common.admin.sidebar.tables_and_lists.assets_preview_request',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'purged-assets',
    name: 'common.admin.sidebar.tables_and_lists.assets_purged',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'browse-library',
    name: 'common.admin.sidebar.tables_and_lists.assets_browse_library',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'map',
    name: 'common.admin.sidebar.tables_and_lists.assets_map',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-rights-partners',
    name: 'common.admin.sidebar.tables_and_lists.rights_partners',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-rights-contracts',
    name: 'common.admin.sidebar.tables_and_lists.rights_contracts',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'other-licensed-packages',
    name: 'common.admin.sidebar.tables_and_lists.licensed_packages',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'other-licensed-packages-connect2',
    name: 'common.admin.sidebar.tables_and_lists.licensed_packages_connect2',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-collections',
    name: 'common.admin.sidebar.tables_and_lists.collections',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-projects',
    name: 'common.admin.sidebar.tables_and_lists.projects',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-suppliers',
    name: 'common.admin.sidebar.tables_and_lists.suppliers',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-workflows',
    name: 'common.admin.sidebar.tables_and_lists.workflows',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-users',
    name: 'common.admin.sidebar.tables_and_lists.users',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-teams',
    name: 'common.admin.sidebar.tables_and_lists.teams',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-orders',
    name: 'common.admin.sidebar.tables_and_lists.orders',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-systems',
    name: 'common.admin.sidebar.tables_and_lists.systems',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-field-options',
    name: 'common.admin.sidebar.tables_and_lists.field_options',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-ratings',
    name: 'common.admin.sidebar.tables_and_lists.ratings',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-preview-requests',
    name: 'common.admin.sidebar.tables_and_lists.preview_requests',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-policies',
    name: 'common.admin.sidebar.tables_and_lists.policies',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-logs',
    name: 'common.admin.sidebar.tables_and_lists.logs',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-delivery-destinations',
    name: 'common.admin.sidebar.tables_and_lists.delivery_destinations',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-discounts',
    name: 'common.admin.sidebar.tables_and_lists.discounts',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-dashboards',
    name: 'common.admin.sidebar.tables_and_lists.dashboard',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-clients',
    name: 'common.admin.sidebar.tables_and_lists.clients',
    hasTable: false,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-shared-packs',
    name: 'common.admin.sidebar.tables_and_lists.shared_packs',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-media-pulse-orders',
    name: 'common.admin.sidebar.tables_and_lists.mediapulse_orders',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-delivery-pack',
    name: 'common.admin.sidebar.tables_and_lists.delivery_pack',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-approved-delivery-packs',
    name: 'common.admin.sidebar.tables_and_lists.approved_delivery_pack',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-rejected-delivery-packs',
    name: 'common.admin.sidebar.tables_and_lists.rejected_delivery_pack',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-metadata-table',
    name: 'common.admin.sidebar.tables_and_lists.metadata-table',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-metadata-table-qc',
    name: 'common.admin.sidebar.tables_and_lists.metadata-table-qc',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'other-metadata-table-qc-layout',
    name: 'common.admin.sidebar.tables_and_lists.metadata-table-qc-layout',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'other-metadata-table-qc-error',
    name: 'common.admin.sidebar.tables_and_lists.metadata-table-qc-error',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'other-metadata-table-qc-text',
    name: 'common.admin.sidebar.tables_and_lists.metadata-table-qc-text',
    hasTable: true,
    hasList: true,
    hasFilters: false,
  },
  {
    key: 'other-audio-specifications',
    name: 'common.admin.sidebar.tables_and_lists.audio-specifications',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-audio-specifications-qc',
    name: 'common.admin.sidebar.tables_and_lists.audio-specifications-qc',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
  {
    key: 'other-hp-search',
    name: 'common.admin.sidebar.tables_and_lists.homepage-search',
    hasTable: false,
    hasList: false,
    hasFilters: true,
  },
  {
    key: 'other-egress-stats',
    name: 'common.admin.sidebar.tables_and_lists.egress-stats',
    hasTable: true,
    hasList: false,
    hasFilters: false,
  },
];

const getSidebarFor = (scope: ConfigurableScopes, inherited: Record<string, string> = {}): AnySidebarItem | null => {
  const configItem = resultsAdminConfig.find((item) => item.key === scope);
  if (!configItem) {
    return null;
  }

  // Honor the backend's wildcard: a `'*'` entry means every scope inherits from the
  // template; a specific scope key overrides it (precedence: scope key > `'*'`).
  const isInherited = !!(inherited[scope] ?? inherited['*']);

  return {
    name: configItem.name,
    routerLink: `/admin/${FIELDS_BASE_PATHS.PAGE_RESULTS_SETTINGS}/${scope}`,
    pill: isInherited ? { label: 'inherited', color: 'cold-blue' } : undefined,
  };
};

export const resultsSettingsNav = (client?: ClientAdminViewModel) => {
  const inherited = client?.resultsSettings.inheritance ?? {};
  const nav = (scope: ConfigurableScopes) => getSidebarFor(scope, inherited);

  return [
    nav('default'),
    nav('browse'),
    nav('adobe-panel'),
    nav('browse-library'),
    nav('deleted'),
    nav('quarantined'),
    nav('qc-required'),
    nav('asset-kits-qc'),
    'separator',
    nav('cart'),
    nav('other-orders'),
    nav('orders'),
    nav('other-media-pulse-orders'),
    nav('other-shared-packs'),
    nav('shared-packs'),
    client?.otherFeatures.flags.salesforceEnabled && nav('other-preview-requests'),
    client?.otherFeatures.flags.salesforceEnabled && nav('preview-request'),
    'separator',
    nav('other-collections'),
    nav('collections'),
    'separator',
    nav('other-projects'),
    nav('projects'),
    'separator',
    nav('other-rights-partners'),
    nav('other-rights-contracts'),
    nav('other-licensed-packages'),
    nav('licensed-package'),
    nav('other-licensed-packages-connect2'),
    nav('connect2'),
    'separator',
    nav('other-delivery-pack'),
    nav('other-approved-delivery-packs'),
    nav('other-rejected-delivery-packs'),
    'separator',
    nav('upload-jobs-draft'),
    nav('upload-jobs-pending'),
    nav('upload-jobs-approved'),
    nav('upload-jobs-rejected'),
    nav('upload-jobs-my-uploads'),
    'separator',
    nav('other-metadata-table'),
    nav('other-metadata-table-qc'),
    nav('other-metadata-table-qc-layout'),
    nav('other-metadata-table-qc-error'),
    nav('other-metadata-table-qc-text'),
    'separator',
    nav('other-audio-specifications'),
    nav('other-audio-specifications-qc'),
    'separator',
    nav('other-hp-search'),
    nav('other-egress-stats'),
  ].filter((item) => !!item) as AnySidebarItem[];
};
